import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import NumberFormat from 'react-number-format';
import Avatar from '../../../Avatar';
import LinkButton from '../../../LinkButton';

const TeamListItem = ({ data, actions }) => {
  const {
    RecruiterID,
    RecruiterName,
    LastLogin,
    MessageCount,
    RatingCount,
    RatingAvg,
    AccessLimits,
    PictureUrl,
  } = data;

  const { onSetAccessLimits } = actions;

  const handleSetAccessLimits = () => {
    onSetAccessLimits(RecruiterID, RecruiterName);
  };

  return (
    <div className="team-list-item">
      <div className="team-list-item__content">
        <div className="team-list-item__block">
          <div className="team-list-item__column team-list-item__column--double">
            <div className="team-list-item__avatar">
              <Avatar size={55} name={RecruiterName} image={PictureUrl} />
            </div>

            <div className="team-list-item__main">
              <span className="team-list-item__name">{RecruiterName}</span>
              <span className="team-list-item__date">
                <span className="team-list-item__label team-list-item__label--always-visible">
                  Last login date:
                </span>{' '}
                {LastLogin === '&nbsp;' ? 'No Login' : LastLogin}
              </span>
              {AccessLimits && (
                <div className="team-list-item__control">
                  <LinkButton
                    text="Set Access Limits"
                    controlFunc={handleSetAccessLimits}
                    btnFontFamily="Poppins, sans-serif"
                    btnFontWeight="700"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="team-list-item__block">
          <div className="team-list-item__column">
            <span className="team-list-item__label">
              <span className="team-list-item__description">
                Messages Sent:
              </span>
            </span>
            <span className="team-list-item__caption">
              <NumberFormat
                thousandSeparator
                value={MessageCount}
                displayType={'text'}
              />
            </span>
          </div>

          <div className="team-list-item__column">
            <span className="team-list-item__label">
              <span className="team-list-item__description">
                # Of Rated Candidates:
              </span>
            </span>
            <span className="team-list-item__caption">
              <NumberFormat
                thousandSeparator
                value={RatingCount}
                displayType={'text'}
              />
            </span>
          </div>

          <div className="team-list-item__column">
            <span className="team-list-item__label">
              <span className="team-list-item__description">
                Average Rating:
              </span>
            </span>
            <span className="team-list-item__caption">
              {' '}
              {`${RatingAvg}/10`}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

TeamListItem.propTypes = {
  data: PropTypes.object,
  actions: PropTypes.object,
};

export default TeamListItem;
